/* eslint-disable prettier/prettier */

export const ACS_CREATE_CHANNEL_DIALOG = "ACS_CREATE_CHANNEL_DIALOG"

export const ACS_CREATE_DIRECT_MESSAGE_DIALOG = "ACS_CREATE_DIRECT_MESSAGE_DIALOG"

export const ACS_DELETE_CHANNEL_DIALOG = "ACS_DELETE_CHANNEL_DIALOG"

export const ACS_ADD_USER_TO_CHANNEL = "ACS_ADD_USER_TO_CHANNEL"

export const ACS_DELETE_MESSAGE = "ACS_DELETE_MESSAGE"


export const CHAT_NAVBAR_ARRAY = [
    {
      name: "Chats",
      id: "chat",
    },
    {
      name: "Groups",
      id: "groups",
    },
    // {
    //   name: "Favorites",
    //   id: "favorites",
    // },
  ];
